export default "__VITE_ASSET__XvD6y00n__"